import { formatMatchCountSummary } from './search-highlight';
import { querySearchInput } from './search-input';

const RESIDENTS_ROOT_SELECTOR = '[data-residency-residents]';
const RESIDENTS_SEARCH_ID = 'residencyResidentsSearch';
const RESIDENTS_SEARCH_MIN_LENGTH = 3;

function countResidentCards(root: ParentNode): number {
  return root.querySelectorAll(`${RESIDENTS_ROOT_SELECTOR} .resident-card`).length;
}

function getResidentsSearchQuery(root: ParentNode): string {
  return root.querySelector<HTMLInputElement>(`#${RESIDENTS_SEARCH_ID}`)?.value.trim() ?? '';
}

function hasActiveResidentsSelectFilters(root: ParentNode): boolean {
  const clusterId = root.querySelector<HTMLSelectElement>('#residencyResidentsCluster')?.value ?? '';
  const directionId =
    root.querySelector<HTMLSelectElement>('#residencyResidentsDirection')?.value ?? '';

  return Boolean(clusterId || directionId);
}

export function updateResidentsSearchSummary(root: ParentNode): void {
  const summary =
    querySearchInput(root, RESIDENTS_SEARCH_ID)?.summary ??
    root.querySelector<HTMLElement>(`[data-search-summary][data-search-for="${RESIDENTS_SEARCH_ID}"]`);

  if (!summary) return;

  const query = getResidentsSearchQuery(root);
  if (query.length < RESIDENTS_SEARCH_MIN_LENGTH) {
    summary.hidden = true;
    summary.innerHTML = '';
    return;
  }

  const count = countResidentCards(root);
  summary.hidden = false;
  summary.innerHTML = formatMatchCountSummary(count, query);
}

export function updateResidentsSelectFiltersSummary(root: ParentNode): void {
  const summary = root.querySelector<HTMLElement>(
    `${RESIDENTS_ROOT_SELECTOR} [data-activity-filters-summary]`,
  );
  if (!summary) return;

  if (!hasActiveResidentsSelectFilters(root)) {
    summary.hidden = true;
    return;
  }

  const query = getResidentsSearchQuery(root);
  if (query.length >= RESIDENTS_SEARCH_MIN_LENGTH) {
    summary.hidden = true;
    return;
  }

  const count = countResidentCards(root);
  summary.hidden = count > 0;
}

export function updateResidentsFiltersSummaries(root: ParentNode): void {
  root.querySelector<HTMLElement>('[data-residents-empty]')?.setAttribute('hidden', '');

  updateResidentsSearchSummary(root);
  updateResidentsSelectFiltersSummary(root);
}
